

    import { defineComponent, onMounted, ref } from 'vue';

    export default defineComponent({

        props: {

            modelValue: Number,
            label: String,
            subLabel: String,
            name: String,
            max: {
                type: Number,
                default: 99

            },
            min: {
                type: Number,
                default: 0

            }
        },

        emits: ["update:modelValue"],


        setup(props, context) {

       
            const getNewValue = (delta: number) => {

                if (props.modelValue == undefined) {

                    // if we are going up, return 1, else default to 0;
                    return Math.max(props.min, delta > 0 ? 1 : 0);
                }
                else {

                    const newVal = props.modelValue + delta;
                    if (newVal < props.min) return props.min;
                    if (newVal > props.max) return (props.max);
                    return newVal;
                }
            };

            const onAdd = () => {

                context.emit('update:modelValue', getNewValue(1));
            }

            const onSubtract = () => {

                context.emit('update:modelValue', getNewValue(-1));
            }


            onMounted(() => {

                const mv = (props.modelValue ?? 0);

                if (mv < props.min) {
                    context.emit('update:modelValue', props.min);
                }
                else if (mv > props.max) {
                    context.emit('update:modelValue', props.max);
                }
            });

            return {
                onAdd,
                onSubtract
            };
        }

    });

